import { render, staticRenderFns } from "./DependencyResolver.vue?vue&type=template&id=79a3f079&"
import script from "./DependencyResolver.vue?vue&type=script&lang=js&"
export * from "./DependencyResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports